import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-gray-200 bg-white mt-auto">
      <div className="mx-auto max-w-7xl px-6 py-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <div className="flex items-center gap-1">
            <span className="text-sm text-gray-500">
              © 2023 Crawly Carl. All rights reserved.
            </span>
          </div>
          
          <div className="flex flex-wrap items-center gap-6 text-sm">
            <a
              href="/privacy"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="/terms"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              Terms of Service
            </a>
            <a
              href="/refund"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              Refund Policy
            </a>
            <a
              href="/shipping"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              Service Delivery
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;